/** camera.ts 가 참조하는 상수 (lazygyu/data/constants.ts 에서 분리) */
export const initialZoom = 30;
export const zoomThreshold = 5;
